import { ICreatePaymentResponse, IRequestPayments } from '@app/core/models/payments.model';

export const MOCK_PAYMENTS_SUCCESS: ICreatePaymentResponse = {
  payment_id: '123456789',
};

export const MOCK_CHECK_PENDING_PAYMENTS_EMPTY: IRequestPayments = {
  results: [],
  filtered: 0,
};
